import type { Column } from '@tanstack/react-table';
import { useMemo } from 'react';
import { ColumnDateAfterFilter } from './ColumnDateAfterFilter';
import { ColumnDropdownFilter } from './ColumnDropdownFilter';
import { ColumnTextInputFilter } from './ColumnTextInputFilter';

type FilterProps<T> = {
    column: Column<T, unknown>;
};

export function Filter<T>({ column }: Readonly<FilterProps<T>>) {
    const columnDef = column.columnDef;
    const { filterVariant } = (columnDef.meta as { filterVariant: 'dateAfter' | 'select' }) ?? {};

    const sortedUniqueValues = useMemo(
        () =>
            Array.from(column.getFacetedUniqueValues().entries())
                .sort(([keyA], [keyB]) => String(keyA).localeCompare(String(keyB)))
                .slice(0, 5000),
        [column.getFacetedUniqueValues(), filterVariant]
    );

    return filterVariant === 'select' ? (
        <ColumnDropdownFilter
            column={column}
            sortedUniqueValues={sortedUniqueValues}
        />
    ) : filterVariant === 'dateAfter' ? (
        <ColumnDateAfterFilter column={column} />
    ) : (
        <ColumnTextInputFilter
            column={column}
            sortedUniqueValues={sortedUniqueValues}
        />
    );
}
